var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import { requiredParam } from 'sdc-utilities';

export default (function (_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === undefined ? requiredParam('backend') : _ref$backend,
      accessKey = _ref.accessKey,
      _ref$path = _ref.path,
      path = _ref$path === undefined ? 'values/' : _ref$path;
  return {
    list: function list(params) {
      return function () {
        if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
          return backend.get(path + params.typeID + (params.accessKey ? '?key=' + params.accessKey : ''));
        } else return backend.get(path + params + (accessKey ? '?key=' + accessKey : ''));
      };
    }
  };
});